import Helper from "../../Helper";
import { DropoffGate } from "../../models/DropoffGate";
import { plotFetch } from "../Helper/ApiRequest";

interface DropoffGateFilters {
    gateId?: number;
    dropoffId?: number;
}

export function getProjectDropoffGates(
    team_subdomain: string,
    project_token: string,
    timezone: string,
    filters: DropoffGateFilters = {}
): Promise<DropoffGate[]> {
    const url = new URL(
        `${Helper.baseUrlAltSubdomain(team_subdomain ? team_subdomain : "projects")}/projects/${project_token}/dropoff_gates`
    );

    if (filters.gateId) url.searchParams.append("gate_id", filters.gateId.toString());
    if (filters.dropoffId) url.searchParams.append("dropoff_id", filters.dropoffId.toString());

    return plotFetch(url.toString(), { method: "GET" }, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return [];
        })
        .then((response) => {
            return response.map((dropoffGate: any) => DropoffGate.fromApiObject(dropoffGate, timezone));
        })
        .catch((_) => {
            return [];
        });
}

export function createDropoffGate(
    team_subdomain: string,
    project_token: string,
    dropoffGate: DropoffGate,
    timezone: string
): Promise<DropoffGate | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/dropoff_gates`;

    return plotFetch(
        url,
        {
            method: "POST",
            body: JSON.stringify({ dropoff_gate: dropoffGate.toApiObject() }),
        },
        true
    )
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return DropoffGate.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

export function updateDropoffGate(
    team_subdomain: string,
    project_token: string,
    dropoffGate: DropoffGate,
    timezone: string
): Promise<DropoffGate | null> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/dropoff_gates/${dropoffGate.id}`;

    return plotFetch(url, {
        method: "PUT",
        body: JSON.stringify({ dropoff_gate: dropoffGate.toApiObject() }),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return null;
        })
        .then((response) => {
            if (response) {
                return DropoffGate.fromApiObject(response, timezone);
            }

            return null;
        })
        .catch((_) => {
            return null;
        });
}

export function deleteDropoffGate(
    team_subdomain: string,
    project_token: string,
    dropoffGate: DropoffGate
): Promise<boolean> {
    const url = `${Helper.baseUrlAltSubdomain(
        team_subdomain ? team_subdomain : "projects"
    )}/projects/${project_token}/dropoff_gates/${dropoffGate.id}`;

    return plotFetch(url, { method: "DELETE" }, true)
        .then((response) => {
            if (response.ok) {
                return true;
            }
            throw new Error("Network error.");
        })
        .catch(() => {
            return false;
        });
}
